var _path, _path2, _rect, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatBotLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5879 25.0886C31.8888 26.1708 28.9753 26.8383 25.9281 27.0112C25.4026 27.041 24.8731 27.0562 24.34 27.0562C23.8069 27.0562 23.2774 27.041 22.7519 27.0112C19.704 26.8382 16.7899 26.1705 14.0903 25.0878C8.42492 22.8158 3.70417 18.7165 0.67334 13.5281C5.39741 5.44098 14.2271 0 24.34 0C34.4529 0 43.2826 5.44098 48.0067 13.5281C44.9755 18.7171 40.254 22.8167 34.5879 25.0886Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0899 27.1939C13.4372 26.9322 12.7971 26.6462 12.1707 26.3371C10.1347 27.7573 8.41365 29.5262 7.11768 31.5443C9.32049 34.9745 12.7515 37.6847 16.8691 39.1868C18.8312 39.9026 20.9492 40.344 23.1644 40.4584H25.4729C27.6876 40.3441 31.5803 42.5168 25.9277 48C30.0459 46.498 39.3165 34.9749 41.5196 31.5443C40.2273 29.5319 38.5123 27.7674 36.484 26.3492C35.8648 26.654 35.2323 26.9362 34.5875 27.1947C31.8884 28.2769 28.975 28.9444 25.9277 29.1173C25.4022 29.1471 24.8727 29.1623 24.3397 29.1623C23.8066 29.1623 23.2771 29.1471 22.7516 29.1173C19.7036 28.9443 16.7895 28.2766 14.0899 27.1939Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.9277,
    y: 10.0676,
    width: 22.8741,
    height: 8.08988,
    rx: 4.04494,
    fill: "#162550"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.673,
    cy: 14.0675,
    rx: 1.49771,
    ry: 1.48315,
    fill: "#04FED1"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.3185,
    cy: 34.0224,
    rx: 1.49771,
    ry: 1.48315,
    fill: "#162550"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.3288,
    cy: 14.0675,
    rx: 1.49771,
    ry: 1.48315,
    fill: "#04FED1"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.3288,
    cy: 34.0224,
    rx: 1.49771,
    ry: 1.48315,
    fill: "#162550"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.3102,
    cy: 34.0224,
    rx: 1.49771,
    ry: 1.48315,
    fill: "#162550"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBotLogo);
export default __webpack_public_path__ + "static/media/chat-bot-logo.ae6d65fc8e13ef01e4e8bf38e9be99ac.svg";
export { ForwardRef as ReactComponent };